export const REQUEST_EXTERNAL = 'REQUEST_EXTERNAL';
export const RESPONSE_VALIDATION_FAILED = 'RESPONSE_VALIDATION_FAILED';
